import { t } from 'i18next';
import { ArrowRightSmall, Attention } from '@peacecover/icon';
import useUserQuery from '../../../components/api/queries/useUserQuery';

interface RefundExchangeNoticeProps {
  className?: string;
}

const RefundExchangeNotice = ({ className = '' }: RefundExchangeNoticeProps) => {
  const user = useUserQuery();
  return (
    <a
      href={`/fanhearts?path=terms&category=refund_exchange_policy&locale=${user?.locale}`}
      className={`flex items-center justify-center gap-[4px] ${className}`}
    >
      <Attention size={16} className="text-text-main-lv3" />
      <p className="text-[13px] font-semibold text-text-main-lv3 leading-[16px]">
        {t('Agreement.refundAndExchange')}
      </p>
      <ArrowRightSmall size={16} className="text-text-main-lv3" />
    </a>
  );
};

export default RefundExchangeNotice;
